import { render, staticRenderFns } from "./EditDelvieryCustomerModal.vue?vue&type=template&id=6fedfdeb&"
import script from "./EditDelvieryCustomerModal.vue?vue&type=script&lang=js&"
export * from "./EditDelvieryCustomerModal.vue?vue&type=script&lang=js&"
import style0 from "./EditDelvieryCustomerModal.vue?vue&type=style&index=0&id=6fedfdeb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports